import Isotope from 'isotope-layout';

window.Isotope = Isotope;
